export default "__VITE_ASSET__f717d233__"